import { useEffect, useState } from 'react';
import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import './Equipe.css';
import dadosEquipe from '../../dados/equipe.json';

// Fotos da equipe guardadas no próprio site (src/dados/equipe.json).
// A ordem é invertida para ficar igual à que o servidor antigo mostrava.
// Coordenadores na ordem do equipe.json (Blayth, Danusa, Giselle, Lucimar),
// a mesma do "Conheça Nossa Equipe" da página inicial.
const coordenadoresArray = dadosEquipe.coordenadores;
const professoresArray = [...dadosEquipe.professores].reverse();
const auxiliaresArray = [...dadosEquipe.auxiliares].reverse();
const allImagesArray = [
  ...coordenadoresArray.map(img => ({ ...img, type: 'Coordenadores' })),
  ...professoresArray.map(img => ({ ...img, type: 'Professores' })),
  ...auxiliaresArray.map(img => ({ ...img, type: 'Auxiliares' }))
];

const Equipe = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }
  }, []);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(`https://drive.google.com/thumbnail?id=${allImagesArray[index].id}&sz=w1080`);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setCurrentIndex(null);
  };

  const goToPreviousImage = () => {
    if (allImagesArray.length > 0) {
      const newIndex = (currentIndex - 1 + allImagesArray.length) % allImagesArray.length;
      setCurrentIndex(newIndex);
      setSelectedImage(`https://drive.google.com/thumbnail?id=${allImagesArray[newIndex].id}&sz=w1080`);
    }
  };

  const goToNextImage = () => {
    if (allImagesArray.length > 0) {
      const newIndex = (currentIndex + 1) % allImagesArray.length;
      setCurrentIndex(newIndex);
      setSelectedImage(`https://drive.google.com/thumbnail?id=${allImagesArray[newIndex].id}&sz=w1080`);
    }
  };

  const renderTeamSection = (title, teamArray) => (
    <div className="team-section">
      <h2 className='titulo-secao'>{title}</h2>
      <div className="team-grid">
        {teamArray.map((image, index) => (
          <div key={index} className="team-member" onClick={() => openLightbox(allImagesArray.findIndex(img => img.id === image.id))}>
            {/* Versão menor (480px) na grade; a grande (1080px) só abre ao clicar */}
            <img src={`https://drive.google.com/thumbnail?id=${image.id}&sz=w480`} alt={`${title} ${index + 1}`} className="professor-image" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
      <Header />
      <main>
      {renderTeamSection('Coordenadores', coordenadoresArray)}
      {renderTeamSection('Professores', professoresArray)}
      {renderTeamSection('Auxiliares', auxiliaresArray)}

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="close-button" onClick={closeLightbox}>X</button>
          <button className="prev-button" onClick={(e) => { e.stopPropagation(); goToPreviousImage(); }}>
            ← <span className="button-text">Anterior</span>
          </button>

          <div className="category-label">
            {allImagesArray[currentIndex].type}
          </div>

          <img 
            src={selectedImage} 
            alt="Professor" 
            className="lightbox-image" 
            onClick={(e) => e.stopPropagation()} 
          />

          <button className="next-button" onClick={(e) => { e.stopPropagation(); goToNextImage(); }}>
            <span className="button-text">Próximo</span> →
          </button>
        </div>
      )}
      </main>
      <Footer />
    </div>
  );
};

export default Equipe;